import {Inject, Injectable} from '@angular/core';
import {I18NEXT_SERVICE, ITranslationService} from 'angular-i18next';
import i18next from 'i18next';
import {availableLanguages} from '../core.const';


@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(@Inject(I18NEXT_SERVICE) public i18NextService: ITranslationService) {
  }

  public translate(key: string, fallback?: string, data: { [key: string]: string } = {}): string {
    return i18next.t(`${key}`, {...data, defaultValue: null}) ?? fallback;
  }

  getAvailableLanguages(): string[] {
    return availableLanguages;
  }
}
